import { useEffect } from 'react';

import { Input, Pagination, Radio, Row, Select, Space } from 'antd';
const { Search } = Input;

import MediaTable from '@Components/Tables/MediaTable';

import useNotification from '@/hooks/notifications';
import useFetchListData from '@/hooks/useFetchListData';

const types = [
	{ label: 'AUDIOS', value: 'audio' },
	{ label: 'PODCASTS', value: 'podcast' },
	{ label: 'VIDEOS', value: 'video' },
	{ label: 'PHOTOS', value: 'photo' },
	{ label: 'PHOTOSETS', value: 'photoset' },
	{ label: 'INFOGRAPHICS', value: 'infographic' },
	{ label: 'STREAMS', value: 'streaming' },
];

const searchTypes = [
	{ label: 'Search by reference ID', value: 'epId' },
	{ label: 'Search by keywords', value: 'search' },
];

export default function MediaList() {
	const {openNotification} = useNotification();

	const {
		setParam,
		setParams,
		searchParams,
		getData,
		data,
		loading,
		pagination,
		error,
		deleteItem
	} = useFetchListData({
		params: null,
		addS: true,
	});

	useEffect(() => {
		if (error) {
			openNotification({message: 'Something went wrong!', description: error.message || null, type: 'error'});
		}
	}, [error]);

	const handleType = ({ target: { value } }) => {
		setParams({type: value, page: null, pageSize: null});
	};

	const handlePagination = (page, pageSize) => {
		setParams({page, pageSize});
	};

	const handleSearch = () => {
		setParams({sort: 'relevancy:asc'});
	};

	return (
		<Space size="large" direction='vertical' style={{width: '100%'}} >
			<h1>{'Media > View by media type'}</h1>
			<Radio.Group
				options={types}
				onChange={handleType}
				value={searchParams.get("type") || 'audio'}
				optionType="button"
				size="large"
			/>
			<Search
				addonBefore={
					<Select
						style={{width: 190}}
						options={searchTypes}
						value={searchParams.get("searchType") || 'search'}
						onChange={setParam('searchType')}
					/>
				}
				value={searchParams.get("search") || ''}
				onChange={setParam('search', false)}
				onSearch={handleSearch}
				enterButton
			/>
			<>
				<MediaTable
					data={data}
					loading={loading}
					sort={searchParams.get("sort") || 'mediaDate:desc'}
					setSort={setParam('sort')}
					getListData={getData}
					type={searchParams.get("type") || 'audio'}
					deleteItem={deleteItem}
				/>
				<Row justify="center">
					<Pagination
						total={pagination.totalElements}
						pageSize={pagination.pageSize}
						current={pagination.page}
						showSizeChanger
						showQuickJumper
						hideOnSinglePage
						disabled={loading}
						onChange={handlePagination}
					/>
				</Row>
			</>
		</Space>
	);
}